import * as React from 'react';
import {Query} from 'react-apollo';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetUser as GetUserQuery, User as UserFragment} from 'nutshell-graphql-types';

import GET_USER from './graphql/queries/get-user.graphql';

type OwnProps = {
    userId: string | null | undefined;
    children: (arg1: ChildrenProps) => React.ReactElement;
};

type ChildrenProps = {
    user: UserFragment | null | undefined;
    errorMessage: string | null | undefined;
    isLoadingUser: boolean;
};

// HOC to get a user from GraphQL
class UserQuery extends Query<GetUserQuery, Record<any, any>> {}

export const GetUser = (props: OwnProps) => {
    return (
        <UserQuery
            query={GET_USER}
            variables={{id: props.userId}}
            // @ts-expect-error
            fetchPolicy='cache-and-network'
            skip={props.userId === ''}
        >
            {({data, error, loading}) => {
                const user = data ? data.user : null;

                return props.children({
                    user,
                    // @ts-expect-error
                    errorMessage: safelyGetGraphQLErrorMessage(error),
                    isLoadingUser: loading,
                });
            }}
        </UserQuery>
    );
};
